import { Icon, Tooltip } from "@/components/atoms";

type LicenceVerificationStatus = "VERIFIED" | "UNVERIFIED" | "EXPIRING_SOON" | "EXPIRED";

interface DriverStatusBadgeProps {
  status: string;
  licenceVerificationStatus?: LicenceVerificationStatus;
}

export const DriverStatusBadge = ({ status, licenceVerificationStatus }: DriverStatusBadgeProps) => {
  const isActive = status.toLowerCase() === "active";

  if (!licenceVerificationStatus) {
    if (isActive) {
      return (
        <Tooltip content="Driver is verified" placement="right">
          <Icon name="Verify" variant="Bold" size="md" className="flex-shrink-0 text-info" />
        </Tooltip>
      );
    }
    return null;
  }

  switch (licenceVerificationStatus) {
    case "VERIFIED":
      return (
        <Tooltip content="Driver is verified" placement="right">
          <Icon name="Verify" variant="Bold" size="md" className="flex-shrink-0 text-info" />
        </Tooltip>
      );
    case "EXPIRING_SOON":
      return (
        <div className="flex flex-row items-center gap-1">
          <Tooltip content="Driver is verified" placement="top">
            <Icon name="Verify" variant="Bold" size="md" className="flex-shrink-0 text-info" />
          </Tooltip>
          <Tooltip content="Driver's License will expire soon." placement="right">
            <Icon name="Danger" variant="Bold" size="md" className="flex-shrink-0 text-warning" />
          </Tooltip>
        </div>
      );
    case "EXPIRED":
      return (
        <div className="flex flex-row items-center gap-1">
          <Tooltip content="Driver is unverified" placement="top">
            <Icon name="Verify" variant="Bold" size="md" className="flex-shrink-0 text-neutral-mid-gray" />
          </Tooltip>
          <Tooltip content="Driver's License has expired." placement="right">
            <Icon name="Danger" variant="Bold" size="md" className="flex-shrink-0 text-danger" />
          </Tooltip>
        </div>
      );
    case "UNVERIFIED":
      return (
        <Tooltip content="Driver is unverified" placement="right">
          <Icon name="Verify" variant="Bold" size="md" className="flex-shrink-0 text-neutral-mid-gray" />
        </Tooltip>
      );
    default:
      return null;
  }
};
